import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { fromEvent, interval, merge, Observable, Observer, of, throwError } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class IsOnlineService{
    private isDev = !environment.production;
    //private urlService = this.isDev ? '/' : 'services/';
    private urlService = environment.baseUrl + '/';
    constructor(private _http : HttpClient) {
    }
    
    public createOnline$() {
        return merge<boolean>(
        fromEvent(window, 'offline').pipe(map(() => false)),
        fromEvent(window, 'online').pipe(map(() => true)),
        new Observable((sub: Observer<boolean>) => {
            sub.next(navigator.onLine);
            sub.complete();
        }));
    }
    
    public makeRequest() {
        return this._http.get(this.urlService + 'api/Seguridad/IsOnline', { observe: 'response' })
        .pipe(
            map((data :any) => {
                if (data.status === 200 ) {
                    return true
                } 
                else {
                    return false
                }
            }),
            catchError(err =>{
                return of(false);
            }),
            first())
    }
}